import { render, staticRenderFns } from "./VSpecialOpeningHour.vue?vue&type=template&id=52cc9678"
import script from "./VSpecialOpeningHour.vue?vue&type=script&lang=ts"
export * from "./VSpecialOpeningHour.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports